import React, { useState, useEffect } from 'react';
import { Grid, Button, Dialog,  DialogTitle,  IconButton, Typography, DialogContent, TextField, DialogActions, CircularProgress, InputAdornment } from '@mui/material';
import ApiRequestService from '../../../../components/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const RegisterAnonymousUser = ({ btnContent }) => {
    const [open, setOpen] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [codeError, setCodeError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const [loading, setLoading] = useState(false);
    const [showCodeTextbox, setShowCodeTextbox] = useState(false);

    useEffect(() => {
        if (open) {
            setFirstName("");
            setLastName("");
            setEmail("");
            setCode("");
            setPassword("");

            setFirstNameError("");
            setLastNameError("");
            setEmailError("");
            setCodeError("");
            setPasswordError("");

            setLoading(false);
            setShowCodeTextbox(false);
        }
    }, [open])

    const validateName = (value) => {
        if (!value.trim()) return "This field is required";
        return "";
    };

    const validateEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) return "Email is required";
        if (!regex.test(value)) return "Enter a valid email address";
        return "";
    };

    const validateCode = (value) => {
        if (value.length < 6) return "Code must be 6 characters in length"
    }

    const validatePassword = (value) => {
        const regex =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!value) return "Password is required";
        if (!regex.test(value))
            return "Must include uppercase, lowercase, number, special character, and be at least 8 characters long";

        return "";
    };

    const validatePasswordAndCofirmPassword = (value) => {
        if (value !== password) {
            return "Passwords does not match"
        }
        return "";
    };

    const handleSendVerifyCode = () => {
        const eError = validateEmail(email);
        setEmailError(eError);
        if (eError) return;

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/sendCodeToAnonymousUser',
            data: {
                emailID: email,
            }
        }).then(res => {

            if (res && res.data && res.data.status === 1) { //failure
                NotificationManager.error(res.data.message, "", 5000);
                return;
            }
            if (res && res.data && res.data.status === 0) {
                // success
                setShowCodeTextbox(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleVerifyCode = () => {
        const eError = validateEmail(email);
        const cError = validateCode(code);
        const fError = validateName(firstName);
        const lError = validateName(lastName);
        const pError = validatePassword(password);
        const cpError = validatePasswordAndCofirmPassword(confirmPassword);

        setEmailError(eError);
        setCodeError(cError);
        setFirstNameError(fError);
        setLastNameError(lError);
        setPasswordError(pError);
        setConfirmPasswordError(cpError);

        if (eError || cError || fError || lError || pError || cpError) return;

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/verifyAnonymousUser',
            data: {
                emailID: email,
                code,
                firstName,
                lastName,
                password,
            }
        }).then(res => {
            if (res && res.data && res.data.status === 1) { //failure
                NotificationManager.error(res.data.message, "", 5000);
                return;
            }
            if (res && res.data && res.data.data) {
                NotificationManager.success("Your email is verified and your account has been registered.");
                let tokenStr = res.data.data;
                const url = new URL(window.location.href);
                url.searchParams.set("token", tokenStr);
                url.searchParams.set("ltiUserID", "");
                window.history.replaceState({}, "", url.toString());
                window.location.reload();
            } else {
                NotificationManager.error("Your code is invalid. Please try again");
            }
        }).finally(() => {
            setLoading(false);
        })

    }

    const handleRegister = () => {
        const fError = validateName(firstName);
        const lError = validateName(lastName);
        const eError = validateEmail(email);
        const pError = validatePassword(password);

        setFirstNameError(fError);
        setLastNameError(lError);
        setEmailError(eError);
        setPasswordError(pError);

        if (fError || lError || eError || pError) return;

        setLoading(true);
        // submit logic
        console.log("Register:", { firstName, lastName, email, password });

        // First send an 6 digit code to that email and verify code here and then call then register


        ApiRequestService({
            method: 'post',
            url: '/registerAnonymousUser',
            data: {
                firstName,
                lastName,
                emailID: email,
                password,
            }
        }).then(res => {
            console.debug("Res>>??", res);
            if (res.data.status === 1) {// error
                NotificationManager.error(res.data.message, "", 5000);
            } else {
                // may be want to refresh the page with new token
            }
        }).finally(() => {
            setLoading(false);
        })
    };

    const onClose = () => {
        setOpen(false);
    }

    return (
        <React.Fragment>

            <Button
                variant="contained"
                style={{
                    color: "#fff",
                }}
                onClick={() => setOpen(true)}
            >
                {btnContent}
            </Button>
            <Dialog
                open={open}
                disableEscapeKeyDown
                maxWidth="sm"
                fullWidth
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    onClose();
                }}
            >
                <DialogTitle>Register User</DialogTitle>
                <DialogContent>
                    <br />
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                            <TextField
                                fullWidth
                                label="Email"
                                placeholder="Enter your email"
                                value={email}
                                // disabled={showCodeTextbox}
                                onChange={(e) => setEmail(e.target.value)}
                                onBlur={() => setEmailError(validateEmail(email))}
                                error={!!emailError}
                                helperText={emailError}
                            />
                        </Grid>
                        {showCodeTextbox ?
                            <Grid item md={12}>
                                <TextField
                                    fullWidth
                                    label="Verification Code"
                                    placeholder="Enter your code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    onBlur={() => setCodeError(validateCode(email))}
                                    error={!!codeError}
                                    helperText={codeError}
                                />
                            </Grid>
                            : null}
                        {showCodeTextbox ?
                            <React.Fragment>
                                <Grid item md={6}>
                                    <TextField
                                        fullWidth
                                        label="First Name"
                                        placeholder="Enter your first name"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        onBlur={() => setFirstNameError(validateName(firstName))}
                                        error={!!firstNameError}
                                        helperText={firstNameError}
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        fullWidth
                                        label="Last Name"
                                        placeholder="Enter your last name"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        onBlur={() => setLastNameError(validateName(lastName))}
                                        error={!!lastNameError}
                                        helperText={lastNameError}
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <TextField
                                        fullWidth
                                        label="Password"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter your password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onBlur={() => setPasswordError(validatePassword(password))}
                                        error={!!passwordError}
                                        helperText={passwordError}
                                    />
                                    <Typography
                                        variant="caption"
                                        sx={{ display: "block", marginTop: "4px", color: "#666" }}
                                    >
                                        Password must include: 1 uppercase, 1 lowercase, 1 number,
                                        1 special character, and be 8+ characters long.
                                    </Typography>
                                </Grid>
                                <Grid item md={12}>
                                    <TextField
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    >
                                                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        label="Confirm Password"
                                        placeholder="Enter your password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        onBlur={() => setConfirmPasswordError(validatePasswordAndCofirmPassword(confirmPassword))}
                                        error={!!confirmPasswordError}
                                        helperText={confirmPasswordError}
                                    />
                                    <Typography
                                        variant="caption"
                                        sx={{ display: "block", marginTop: "4px", color: "#666" }}
                                    >
                                        Password must include: 1 uppercase, 1 lowercase, 1 number,
                                        1 special character, and be 8+ characters long.
                                    </Typography>
                                </Grid>
                            </React.Fragment>
                            : null}

                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button disabled={loading} variant="outlined" onClick={onClose}>Cancel</Button>
                    {showCodeTextbox ?
                        <Button disabled={loading || password != confirmPassword} variant="contained" onClick={handleVerifyCode}>
                            <div className='d-flex justify-content-center align-items-center' style={{ gap: "4px" }}>
                                {loading ? <CircularProgress size={18} /> : null}
                                <div>Verify & Register</div>
                            </div>
                        </Button>
                        :
                        <div>
                            {/* <Button className='mr-2' disabled={loading} variant="text" onClick={() => {
                setShowCodeTextbox(true);
              }}>I have the code</Button> */}
                            <Button disabled={loading} variant="contained" onClick={handleSendVerifyCode}>
                                <div className='d-flex justify-content-center align-items-center' style={{ gap: "4px" }}>
                                    {loading ? <CircularProgress size={18} /> : null}
                                    <div>Send Code</div>
                                </div>
                            </Button>
                        </div>
                    }
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

export default RegisterAnonymousUser;
